import React, { useEffect, useRef, useState } from 'react';
import { Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';
import SingleFilter from './SingleFilter';
import FiltersModal from './FiltersModal';
import './style.scss';
import SingleBranchLoadable from './SingleBranchLoadable';
import GoogleMapReact from 'google-map-react';
import clsx from 'clsx';
import SingleLocationPin from './SingleLocationPin';
import LeftSideComponent from './LeftSideComponent';
import { filterItems } from './helper';
import { Swiper } from 'swiper/react/swiper-react.js';
import { SwiperSlide } from 'swiper/react/swiper-react.js';
import 'swiper/swiper.scss';
import 'swiper/modules/pagination/pagination.scss';

const mapIcon = '/-/media/Project/FAB2/Fab2/data/media/svgs/icons/icon-map';
const listIcon = '/-/media/Project/FAB2/Fab2/data/media/svgs/icons/icon-list';
const filterIcon = '/-/media/Project/FAB2/Fab2/data/media/svgs/icons/icon-filter';
const searchIcon = '/-/media/Project/FAB2/Fab2/data/media/svgs/icons/icon-filter-search';
const checkIcon = '/-/media/Project/FAB2/Fab2/data/media/svgs/icons/icon-checkbox-button-selected';

const defaultZoom = 11;

const BranchesAndATMs = ({ fields = {}, i18n, t, params, sitecoreContext }) => {
  const { title, items, branchServices, mapCenterLatitude, mapCenterLongitude } = fields;

  const { hideTimings, minimalLayout, hideFacilities } = params;

  // Conditional Rendering
  const shouldRenderTitle = !!title?.value;
  const shouldRenderItems = Array.isArray(items) && items.length > 0;
  const shouldRenderBranchServices = Array.isArray(branchServices) && branchServices.length > 0;

  // Main items
  const mainItems = shouldRenderItems ? items : []
  const [filteredItems, setFilteredItems] = useState(mainItems);

  // Number of selected checkboxes
  const [numberOfSelectedCheckboxes, setNumberOfSelectedCheckboxes] = useState(0);

  // All filters
  const [allFilters, setAllFilters] = useState({
    servicesFilter: [],
    locationFilter: [],
    bankingExperienceFilter: [],
  });
  // Filters Popup Modal
  const [showModal, setShowModal] = useState(false);
  const moreFiltersClick = () => setShowModal(true);

  // Map data
  const [mapCenter, setMapCenter] = useState({
    lat: mapCenterLatitude?.value,
    lng: mapCenterLongitude?.value,
  });
  const [mapZoom, setMapZoom] = useState(defaultZoom);

  // Map Card
  const [selectedMapCard, setSelectedMapCard] = useState(-1);

  // Left side nav
  const [leftSideComponentToggle, setLeftSideComponentToggle] = useState(false);

  const [userLocation, setUserLocation] = useState({});

  // Current Location
  const [currentLocationChecked, setCurrentLocation] = useState(false);

  const currentLocationClick = () => {
    if (currentLocationChecked) {
      setCurrentLocation(false);
      setMapCenter({
        lat: mapCenterLatitude?.value,
        lng: mapCenterLongitude?.value,
      });
      setMapZoom(defaultZoom);
    } else {
      navigator.geolocation.getCurrentPosition((position) => {
        setMapZoom((prev) => ++prev);
        const p = position.coords;
        setUserLocation({
          lat: p.latitude,
          lng: p.longitude,
        });
        setMapCenter({
          lat: p.latitude,
          lng: p.longitude,
        });
      });
      setCurrentLocation(true);
    }
  };

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) => {
      const p = position.coords;
      setUserLocation({
        lat: p.latitude,
        lng: p.longitude,
      });
    });
  }, []);

  const [selectedLocationCard, setSelectedLocationCard] = useState(-1);
  const [selectedMobileLocationCard, setSelectedMobileLocationCard] = useState(0);

  // selected radio button
  /**
   * index = 0 -> Now Open
   * index = 1 -> 24x7
   * index = 2 -> Closed Temporarily
   */
  const [selectedRadioButton, setSelectedRadioButton] = useState(-1);

  const outerSearchClick = () => {
    filterItems(
      items,
      allFilters,
      setFilteredItems,
      selectedRadioButton,
      setSelectedLocationCard,
      setSelectedMapCard,
      setLeftSideComponentToggle
    );
  };

  /**
   * map/list options on mobile
   * true -> map
   * false -> list
   */
  const [isMap, setIsMap] = useState(true);

  const swiperRef = useRef();

  return (
    <div
      className={clsx(
        'branches__wrapper',
        leftSideComponentToggle && 'full-height',
        'add-margins',
        params?.Styles
      )}
    >
      <LeftSideComponent
        leftSideComponentToggle={leftSideComponentToggle}
        setLeftSideComponentToggle={setLeftSideComponentToggle}
        fields={fields}
        t={t}
        data={filteredItems[selectedLocationCard]}
        params={params}
        i18n={i18n}
      />

      <FiltersModal
        allFilters={allFilters}
        setAllFilters={setAllFilters}
        filtersData={fields}
        showModal={showModal}
        setModalShow={setShowModal}
        t={t}
        items={items}
        numberOfSelectedCheckboxes={numberOfSelectedCheckboxes}
        setNumberOfSelectedCheckboxes={setNumberOfSelectedCheckboxes}
        setFilteredItems={setFilteredItems}
        selectedRadioButton={selectedRadioButton}
        setSelectedRadioButton={setSelectedRadioButton}
        setSelectedLocationCard={setSelectedLocationCard}
        setSelectedMapCard={setSelectedMapCard}
        setLeftSideComponentToggle={setLeftSideComponentToggle}
        hideTimings={hideTimings}
      />
      <div className="branches__wrapper-top">
        {shouldRenderTitle && (
          <h2 className="branches__wrapper-top_heading">
            <Text field={title} />
          </h2>
        )}
        <div className="branches__wrapper-top_filters-container">
          {shouldRenderBranchServices && (
            <div className="branches__wrapper-top_filters">
              {branchServices.map((item, index) => {
                return (
                  <SingleFilter
                    key={index}
                    data={item}
                    allFilters={allFilters}
                    setAllFilters={setAllFilters}
                    type="services"
                    setNumberOfSelectedCheckboxes={setNumberOfSelectedCheckboxes}
                  />
                );
              })}
            </div>
          )}
          <div onClick={moreFiltersClick} role="button" className="filter-action rounded-div">
            {numberOfSelectedCheckboxes > 0 && (
              <span className="filter-action_number">{numberOfSelectedCheckboxes}</span>
            )}
            <span className="filter-action_content">{t('filterTitle')}</span>
            <img src={filterIcon} alt="filter" />
          </div>
          <div role="button" onClick={outerSearchClick} className="search-action">
            <img src={searchIcon} alt="search" />
          </div>
        </div>
      </div>
      <div
        className="branches__wrapper-container"
        id={!isMap ? 'list-mobile-container' : undefined}
      >
        <div className="branches__wrapper-container_left">
          <div className="branches__wrapper-container_wrapper">
            {shouldRenderItems &&
              filteredItems.map((item, index) => {
                return (
                  <SingleBranchLoadable
                    t={t}
                    key={index}
                    index={index}
                    data={item.fields}
                    setSelectedMapCard={setSelectedMapCard}
                    setSelectedLocationCard={setSelectedLocationCard}
                    setLeftSideComponentToggle={setLeftSideComponentToggle}
                    setMapCenter={setMapCenter}
                    setMapZoom={setMapZoom}
                    withDirection={true}
                    fields={fields}
                    params={params}
                    i18n={i18n}
                    hideTimings={hideTimings}
                    hideFacilities={hideFacilities}
                    minimalLayout={minimalLayout}
                  />
                );
              })}
          </div>
        </div>
        <div className="branches__wrapper-container_right">
          <div
            role="button"
            onClick={currentLocationClick}
            className="branches__wrapper-top_filter use-current"
          >
            <div className={clsx('checkmark', currentLocationChecked && 'checked')}>
              <img src={checkIcon} alt="check" />
            </div>
            {t('useCurrentLocation')}
          </div>
          {shouldRenderItems && isMap && (
            <div className="main-mobile-wrapper">
              <Swiper
                ref={swiperRef}
                onInit={() => {
                  setMapCenter(
                    items[0]?.fields?.longitude?.value && items[0]?.fields?.latitude?.value
                      ? {
                          lng: items[0]?.fields?.longitude?.value,
                          lat: items[0]?.fields?.latitude?.value,
                        }
                      : {
                          lng: mapCenterLongitude?.value,
                          lat: mapCenterLatitude?.value,
                        }
                  );
                }}
                onSlideChange={(e) => {
                  setSelectedMobileLocationCard(e.activeIndex);
                  setMapCenter({
                    lng: items[e.activeIndex]?.fields?.longitude?.value,
                    lat: items[e.activeIndex]?.fields?.latitude?.value,
                  });
                  setMapZoom(16);
                }}
                className="main-mobile-swiper"
                spaceBetween={8}
                dir={i18n.language === 'en' ? 'ltr' : 'rtl'}
                autoHeight={false}
                slidesPerView={'auto'}
                slidesPerGroup={1}
                centeredSlides={true}
              >
                {filteredItems.map((item, index) => {
                  return (
                    <SwiperSlide className="main-mobile-swiper_slide" key={index}>
                      <SingleBranchLoadable
                        t={t}
                        key={index}
                        index={index}
                        data={item.fields}
                        setSelectedMapCard={setSelectedMapCard}
                        setSelectedLocationCard={setSelectedLocationCard}
                        setLeftSideComponentToggle={setLeftSideComponentToggle}
                        setMapCenter={setMapCenter}
                        setMapZoom={setMapZoom}
                        withDirection={true}
                        fields={fields}
                        params={params}
                        i18n={i18n}
                        hideTimings={hideTimings}
                        hideFacilities={hideFacilities}
                        minimalLayout={minimalLayout}
                      />
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
          )}
          <div className="goolge-map-react">
            <GoogleMapReact
              bootstrapURLKeys={{ key: sitecoreContext?.siteConfigurations?.googleMapApiKey }}
              zoom={mapZoom}
              onZoomAnimationEnd={(e) => {
                setMapZoom(e);
              }}
              center={mapCenter}
              onClick={() => {
                setSelectedMobileLocationCard(-1);
                setSelectedMapCard(-1);
                setSelectedLocationCard(-1);
                setLeftSideComponentToggle(false);
              }}
            >
              {userLocation?.lat && userLocation?.lng && (
                <SingleLocationPin
                  lat={userLocation.lat}
                  lng={userLocation.lng}
                  justPin
                  params={params}
                  i18n={i18n}
                />
              )}
              {shouldRenderItems &&
                filteredItems.map((item, index) => {
                  return (
                    <SingleLocationPin
                      lat={item?.fields?.latitude?.value}
                      lng={item?.fields?.longitude?.value}
                      data={item}
                      index={index}
                      dataCard={selectedMapCard !== -1 && filteredItems[selectedMapCard]?.fields}
                      fields={fields}
                      selectedMapCard={selectedMapCard}
                      t={t}
                      setSelectedMapCard={setSelectedMapCard}
                      key={index}
                      setSelectedLocationCard={setSelectedLocationCard}
                      setLeftSideComponentToggle={setLeftSideComponentToggle}
                      setMapZoom={setMapZoom}
                      setMapCenter={setMapCenter}
                      selectedMobileLocationCard={selectedMobileLocationCard}
                      setSelectedMobileLocationCard={setSelectedMobileLocationCard}
                      swiperRef={swiperRef}
                      params={params}
                      i18n={i18n}
                    />
                  );
                })}
            </GoogleMapReact>
          </div>
        </div>
        <button
          onClick={() => {
            setSelectedMobileLocationCard(0);
            setMapZoom(defaultZoom);
            setIsMap((prev) => !prev);
          }}
          className={clsx('view-option-btn', isMap ? 'view-map' : 'view-list')}
        >
          {isMap ? (
            <>
              <span>{t('list')}</span>
              <img src={listIcon} alt="list" />
            </>
          ) : (
            <>
              <span>{t('map')}</span>
              <img src={mapIcon} alt="map" />
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default withTranslation()(withSitecoreContext()(BranchesAndATMs));
